<template>
	<form @submit.prevent="editUser()" class="mb-5">
		<h1 class="custom-dark-text">Edit User</h1>
		<div class="row">
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="firstName"
					label="First Name"
					type="text"
					class="form-control form-control-lg dashInput"
					v-model="user.firstName"
					rules="required|min:3|max:40"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="lastName"
					label="Last Name"
					type="text"
					class="form-control form-control-lg dashInput"
					v-model="user.lastName"
					rules="required|min:3|max:40"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="phone"
					label="Mobile Number"
					type="number"
					:min="0"
					class="form-control form-control-lg dashInput"
					v-model="user.phone"
					rules="required|min:10|max:10"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="email"
					label="Email"
					type="email"
					v-model="user.email"
					class="form-control form-control-lg dashInput"
					rules="required|email"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>

			<div class="form-group col-sm-6">
				<BaseMultiSelect
					@update:value="setRole"
					:options="multiSelectState.rolesSelect"
					:defaultData="user.role[0]"
					rules="required"
					mode="single"
					name="Role"
					:required="true"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div v-if="user.role !== roles.env_admin" class="form-group col-sm-6">
				<BaseMultiSelect
					@update:value="setUser"
					:options="multiSelectState.userSelect"
					:defaultData="
						user?.assignTo instanceof Array ? user?.assignTo[0]?._id : ''
					"
					rules="required"
					mode="single"
					name="Assign To"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="area"
					label="Area"
					type="text"
					v-model="user.area"
					class="form-control form-control-lg dashInput"
					rules="required|min:4|max:50"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6">
				<BaseMultiSelect
					@update:value="setTargetType"
					:defaultData="user.targetType"
					:options="multiSelectState.targetSelect"
					rules="required"
					mode="single"
					name="Target Complete In"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="enquiryTarget"
					label="Enquiry Target"
					type="number"
					:min="0"
					class="form-control form-control-lg dashInput"
					v-model="user.enquiryTarget"
					rules="required|min:1"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="bookingTarget"
					label="Booking Amount Target"
					type="number"
					:min="0"
					class="form-control form-control-lg dashInput"
					v-model="user.bookingTarget"
					rules="required|min:1"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="Google App Password"
					label="Google App Password"
					type="text"
					v-model="user.googleAppPass"
					class="form-control form-control-lg dashInput"
					rules="required"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="col-sm-12">
				<div class="form-check form-switch">
					<input
						class="form-check-input"
						v-model="image.enabled"
						type="checkbox"
						id="imageCheck"
					/>
					<label class="form-check-label text-dark" for="imageCheck"
						>Upload user image</label
					>
				</div>
			</div>
			<div v-if="image.enabled" class="col-sm-12">
				<BaseImageUpload urlParam="users" @images-data="setImage" />
			</div>
			<div class="form-group col-sm-6 mb-5">
				<div class="form-check form-switch">
					<input
						class="form-check-input"
						v-model="password.status"
						type="checkbox"
						id="passwordCheck"
					/>
					<label class="form-check-label custom-dark-text" for="passwordCheck"
						>Do you want to change password?</label
					>
				</div>
			</div>
			<div v-if="password.status" class="row">
				<div class="form-group col-sm-5 mb-4">
					<BaseInput
						name="New Password"
						label="New Password"
						:type="password.type"
						v-model="password.password"
						rules="required|min:6|max:30"
						class="form-control form-control-lg dashInput"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
				</div>

				<div class="form-group col-sm-5 mb-4">
					<BaseInput
						name="Confirm Password"
						label="Confirm Password"
						:type="password.type"
						v-model="password.confirmPassword"
						rules="required|min:6|max:30"
						class="form-control form-control-lg dashInput"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
					<span v-if="password.error" class="text-danger small">{{
						password.error
					}}</span>
				</div>
				<div
					class="form-group col-sm-2 mb-4 d-flex justify-content-evenly align-items-center"
				>
					<i
						@click="changePassword"
						:class="`cursor-pointer bi ${password.icon}`"
					></i>
					<span class="small text-muted">{{
						password.type === "text" ? "Hide Password" : "Show Password"
					}}</span>
				</div>
			</div>

			<div class="form-group col-sm-6 mt-2 mb-4">
				<BaseButton
					class="btn btn-primary form-control"
					type="submit"
					label="Update"
					:disabled="formState.disable"
					:loading="formState.isLoading"
				/>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, inject, watch } from "vue";
	import { useRouter } from "vue-router";
	import API from "@/config/api";
	import BaseInput from "./BaseInput.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseButton from "./BaseButton.vue";
	import BaseImageUpload from "./BaseImageUpload.vue";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";

	export default {
		name: "UserEdit",

		components: {
			BaseInput,
			BaseButton,
			BaseMultiSelect,
			BaseImageUpload,
		},

		setup: (props) => {
			const store = inject("store");
			const masterStore = inject("masterStore");
			const roles = reactive({
				env_admin: process.env.VUE_APP_USER_ADMIN,
			});
			const router = useRouter();
			if (!store.state.auth.isAuth) router.push({ name: "Login" });

			const user = reactive({
				firstName: masterStore.state.data.firstName,
				lastName: masterStore.state.data.lastName,
				phone: masterStore.state.data.phone,
				email: masterStore.state.data.email,
				role: [masterStore.state.data.role[0].replace(" ", "_")],
				assignTo:
					masterStore.state.data.assignTo instanceof Array
						? masterStore.state.data.assignTo
						: "",
				area: masterStore.state.data.area,
				targetType: masterStore.state.data.targetType,
				enquiryTarget: masterStore.state.data.enquiryTarget,
				bookingTarget: masterStore.state.data.bookingTarget,
				image: masterStore.state.data?.image || null,
				googleAppPass: masterStore.state.data?.googleAppPass || null,
			});

			const multiSelectState = reactive({
				rolesSelect: Helper.roles.map((role) => ({
					value: role,
					label: role.replace(/_/g, " "),
				})),
				userSelect: [],
				targetSelect: ["Days", "Month"],
			});

			const image = reactive({
				enabled: false,
			});

			if (
				masterStore.state?.data?.assignTo instanceof Array &&
				masterStore.state?.data?.assignTo.length
			) {
				multiSelectState.userSelect = masterStore.state.data.assignTo.map(
					(user) => ({
						label: `${user.firstName} ${user.lastName}`,
						value: user._id,
					}),
				);
			}

			const password = reactive({
				status: false,
				password: null,
				confirmPassword: null,
				error: null,
				type: "password",
				show: false,
				icon: "bi-eye",
			});

			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: ["enquiryTarget", "bookingTarget"],
			});

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			const editUser = async () => {
				changeFormLoadingState();
				formState.disable = true;

				// if(validation.invalid.length) {
				//     toast.error('Incomplete form', true)
				//     changeFormLoadingState()
				//     return
				// }

				try {
					let data = { ...user };
					if (password.status) {
						data.password = password.password;
					}

					await API.privateRequest.patch(
						"users/" + masterStore.state.editId,
						data,
					);
					toast.success(
						{ message: "User Updated!", position: "topRight" },
						true,
					);

					changeFormLoadingState();
					masterStore.methods.changeComponent("table");
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
					changeFormLoadingState();
					formState.disable = false;
				}
			};

			const changePassword = () => {
				if (password.icon === "bi-eye") {
					password.icon = "bi-eye-slash";
					password.type = "text";
				} else {
					password.icon = "bi-eye";
					password.type = "password";
				}
			};

			watch(
				() => password,
				(newVal, preVal) => {
					if (
						password.password !== password.confirmPassword &&
						!password.error
					) {
						password.error = "New password and confirm password are not same.";
						formState.disable = true;
					}
					if (
						password.password === password.confirmPassword &&
						password.error
					) {
						formState.disable = false;
						password.error = null;
					}
				},
				{ deep: true },
			);

			const getUsers = async () => {
				try {
					let query = "";

					if (!user.role.length) return;
					else if (user.area)
						query = `selectedRole=${user.role[0]}&area=${user.area}`;
					else query = `selectedRole=${user.role[0]}&`;

					const response = await API.privateRequest.get(`users?${query}`);

					multiSelectState.userSelect = response.data.data.map((user) => ({
						label: `${user.firstName} ${user.lastName}`,
						value: user._id,
					}));
				} catch (err) {
					console.log("error getting users");
					console.log(err);
				}
			};

			//? checking conditions to enable or disable form login button
			const checkForm = () => {
				let inValLength = validation.invalid.length;

				if (inValLength) {
					formState.disable = true;
				} else formState.disable = false;
			};

			//? adding and removing form fields from valid and invalid state
			const setFormVal = (data) => {
				if (validation.invalid.length) {
					const newInvalid = validation.invalid.filter(
						(error) => error.field !== data.field,
					);
					validation.invalid = newInvalid;
				}
				if (validation.valid.length) {
					const newValid = validation.valid.filter(
						(item) => item.field !== data.field,
					);
					validation.valid = newValid;
				}
				return;
			};

			const setUser = (payload) => {
				user.assignTo = payload;
			};

			const setRole = (payload) => {
				user.role[0] = payload;
				getUsers();
			};

			const setTargetType = (payload) => {
				user.targetType = payload;
			};
			const setImage = (images) => {
				if (!images.length) return;
				user.image = images[0];
				formState.disable = false;
				if (masterStore.state.data._id === store.state.user.id) {
					store.methods.changeImage(user.image);
				}
			};

			// event handler for valError event
			const valError = (data) => {
				// toast.error(`${data.field} is required`, true);
				setFormVal(data);
				validation.invalid = [...validation.invalid, data];
				checkForm();
			};

			const valSuccess = (data) => {
				setFormVal(data);
				validation.valid = [...validation.valid, data];
				checkForm();
			};

			return {
				user,
				roles,
				multiSelectState,
				image,
				password,
				editUser,
				changePassword,

				setUser,
				setRole,
				setTargetType,
				setImage,

				valError,
				valSuccess,
				validation,
				formState,
			};
		},
	};
</script>
